import {React , useState , useEffect} from 'react'
import "./AllSubEvents.css"
import { getAllSubEvents } from '../../../services/Api';
import EventCard from '../../../components/SubEventCard/SubEventCard';

const AllEvents = () => {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    const getEvents = async () => {
      const data = await getAllSubEvents();
      console.log(data.data);
      if (data?.data) setEvents(data?.data);
    };
    getEvents();
  }, []);

  return (
    <div className="events-container">
      {events?.length ? (
        events?.map((elem) => (
            
            <EventCard
              id={elem.id}
              name={elem.name}
              description={elem.description}
              start_time={elem.start_time.slice(10)}
              end_time={elem.end_time.slice(10)}
              start_date={elem.start_time.slice(0,10)}
              end_date={elem.start_time.slice(0,10)}
            />
          ))
      ) : (
        <>
          <div className="info">No events added</div>
        </>
      )}
    </div>
  );
};

export default AllEvents;
